import { useCallback, useEffect, useState } from 'react';

/**
 * A piece of UI preference persisted to localStorage (e.g. layout density,
 * quick-view behavior). Survives reloads; falls back to `initial` when unset or
 * unparsable.
 */
export function useLocalPref(key, initial) {
  const [value, setValue] = useState(() => {
    try {
      const raw = localStorage.getItem(key);
      return raw === null ? initial : JSON.parse(raw);
    } catch {
      return initial;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch {
      /* ignore quota/availability errors */
    }
  }, [key, value]);

  const update = useCallback((next) => setValue(next), []);
  return [value, update];
}
